import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

// bottsrtap bundle
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css'

// importa le configurazioni per gli end-point delle ApiREST
process.env.NODE_ENV === 'production' ? require( './config' ) : require( './config.local' )


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
